import PillarChapterWrapper from './PillarChapterWrapper'

export default PillarChapterWrapper